import { backendStatusAtom } from '@australiangreens/ag-internal-components';
import { getDefaultStore } from 'jotai';

/** Matches TanStack Query's default max retry count. */
export const DEFAULT_QUERY_RETRY_COUNT = 3;

/**
 * React Query `retry` callback: stop retrying while an outage is latched.
 * Avoids CORS/network console floods without pausing the client (Redis recovery
 * still needs invalidate → fetch).
 */
export function shouldRetryQuery(
  failureCount: number,
  maxRetries: number = DEFAULT_QUERY_RETRY_COUNT
): boolean {
  const { status } = getDefaultStore().get(backendStatusAtom);
  if (status === 'DOWN') return false;
  return failureCount < maxRetries;
}
